import { makeApiUrl, makeHttpClient } from '../../http';
import { DeleteShift as UsecaseRemoteDeleteShift } from '~/domain/usecases/teleShifts/remote';
import { RemoteDeleteShift } from '~/data/repository/teleShifts';

export const makeRemoteDeleteShift = (): UsecaseRemoteDeleteShift =>
  new RemoteDeleteShift(makeApiUrl('/shifts/{shift}'), makeHttpClient());
